import { SmsRepositoryImpl } from 'repository/grapqhlRepository/smsRepository';
import { type CloudResult } from 'repository/repository';
import type SmsService from 'services/sms/smsService';
import { displayErrorMessage } from 'services/utils';
import { type Sms } from 'typedefs/sms';

export class SmsServiceImpl implements SmsService {
  smsRepository = new SmsRepositoryImpl();
  async sendSMS(message: string, personCSIds: string[], tournamentId: string): Promise<CloudResult<Sms>> {
    const sendSmsResult = await this.smsRepository.sendSMS(message, personCSIds, tournamentId);

    // show toaster with error message if it exists
    displayErrorMessage<Sms>(sendSmsResult);

    return Promise.resolve(sendSmsResult);
  }
  async sendStaffSMS(message: string, staffId: string, tournamentId: string): Promise<CloudResult<Sms>> {
    const sendStaffSmsResult = await this.smsRepository.sendStaffSMS(message, staffId, tournamentId);

    // show toaster with error message if it exists
    displayErrorMessage<Sms>(sendStaffSmsResult);

    return Promise.resolve(sendStaffSmsResult);
  }
}
